export default {"src":"/_next/static/media/walnuts.4e36fa60.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};